import { authFetch, BASE_BACKEND_URL } from '../auth'
import { faSortDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useMemo, useState } from 'react'
import { Table } from 'react-bootstrap'
import LoadingScreen from '../components/LoadingScreen'
import { canManageRoutePlans } from '../global_context/capabilities/routePlanCapabilities'
import { DAY_DIC } from '../pos/constants/constants'
import { sortClients } from '../route/helpers/utils'
import dayjs from '../utils/dayjsConfig'

const ShowRoutePlanView = () => {
  const [routeData, setRouteData] = useState(null)
  const [isFetching, setIsFetching] = useState(true)
  const [suspending, setSuspending] = useState(false)
  const [id, setId] = useState(window.location.href.split('/').pop())
  const [showDropdown, setShowDropdown] = useState(false)

  useEffect(() => {
    fetchDetailsFromServer()
  }, [id])

  ////// Stops fetchs when page is changed
  const abortController = new AbortController()
  const abortCurrentFetchs = () => {
    abortController.abort('Fetch Aborted by User.')
  }
  window.addEventListener('beforeunload', abortCurrentFetchs)
  //////

  const fetchDetailsFromServer = () => {
    setIsFetching(true)
    authFetch(`${BASE_BACKEND_URL}/route_plans/${id}`, {
      method: 'GET',
      signal: abortController.signal,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }
    })
      .then((response) => {
        if (!response) return
        return response.json()
      })
      .then((data) => {
        setRouteData(data)
        setIsFetching(false)
      })
      .catch((error) => {
        if (error !== 'Fetch Aborted by User.') {
          console.error('Error:', error)
        }
      })
  }

  const suspendRoutePlan = (event, data) => {
    event.preventDefault()
    setSuspending(true)
    const response = window.confirm('¿Está seguro de que desea deshabilitar este plan de visitas?')
    if (response === true) {
      authFetch(`${BASE_BACKEND_URL}/route_plans/${data.uid}`, {
        method: 'DELETE',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        }
      })
        .then(() => (window.location = `/plan_de_visitas/${data.uid}`))
        .catch((e) => console.log(e))
    } else {
      setSuspending(false)
    }
  }

  const copyRoutePlan = (event, data) => {
    event.preventDefault()
    const response = window.confirm(
      '¿Está seguro de crear una copia a partir de este plan de visitas?'
    )
    if (response === true) {
      window.location = `/crear_plan_de_visita?copy=${data.uid}`
    }
  }

  const editRoutePlan = (event, data) => {
    event.preventDefault()
    window.location = `/crear_plan_de_visita?edit=${data.uid}`
  }

  const getFormattedDate = (date) => {
    return date ? new Date(date).toLocaleString() : '-'
  }

  const getAssignedUsers = (allUsers) => {
    const allUserNames = allUsers.map((user) => user.user_name)
    return allUserNames.join(', ')
  }

  const getRecurrenceInWords = (recurrence, type) => {
    const visitAmount =
      type !== undefined ? parseInt(recurrence) / parseInt(type) : parseInt(recurrence) / 7
    if (recurrence == 7) return 'Cada semana'
    if (visitAmount == 1 && type == '28') return 'Cada mes'
    if (type == '28') return `Cada ${visitAmount} meses`
    return `Cada ${visitAmount} semanas`
  }

  const getVisitDaysInWords = (weekDays) => {
    const days = weekDays.map((day) => DAY_DIC[day])
    return days.join(', ')
  }

  const sortedClients = useMemo(() => {
    if (routeData?.route_plan_form_info?.clients) {
      return sortClients(routeData.route_plan_form_info.clients);
    }
    return [];
  }, [routeData?.route_plan_form_info?.clients]);

  if (isFetching) {
    return <LoadingScreen text="Cargando..." />
  }

  return (
    <>
      <div className="main-show-header">
        <h2>
          Plan de visitas: {routeData?.external_uid} - {routeData?.title}
        </h2>
      </div>
      <div className="index-table">
        <div className="show-area">
          <div className="container-fluid">
            <div className="row show-product-header">
              <div className="d-flex align-flex-center justify-flex-between">
                <p className="details-title">Detalles de plan de visitas:</p>
                <div>
                  {canManageRoutePlans() && (
                      <>
                        {routeData.status == 'created' && (
                          <>
                            <button
                              disabled={suspending}
                              onClick={(e) => editRoutePlan(e, routeData)}
                              type="submit"
                              className="ubiqua-secondary-btn mr-10"
                            >
                              Editar plan de visitas
                            </button>

                            <div className="download-report-container">
                              <button
                                onClick={() => setShowDropdown(!showDropdown)}
                                className="btn btn-default route-options-button-drop"
                              >
                                Opciones del plan de visitas
                                <span className="route-options-button-drop-divider"></span>
                                <FontAwesomeIcon
                                  icon={faSortDown}
                                  style={{ right: '0.5px' }}
                                />
                              </button>
                              {showDropdown && (
                                <div className="route-options-menu-drop">
                                  <button
                                    className="route-options-item-drop"
                                    onClick={(e) => {
                                      copyRoutePlan(e, routeData)
                                      setShowDropdown(false)
                                    }}
                                  >
                                    Crear copia del plan de visitas
                                  </button>
                                  <button
                                    className="route-options-item-drop"
                                    onClick={(e) => {
                                      suspendRoutePlan(e, routeData)
                                      setShowDropdown(false)
                                    }}
                                  >
                                    Deshabilitar plan de visitas
                                  </button>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                        {routeData.status == 'disabled' && (
                          <button
                            disabled={suspending}
                            type="submit"
                            onClick={(e) => copyRoutePlan(e, routeData)}
                            className="ubiqua-primary-btn"
                          >
                            Crear copia del plan de visitas
                          </button>
                        )}
                      </>
                    )}
                </div>
              </div>
            </div>
            <hr />

            <table cellSpacing="10">
              <tbody>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Nombre del plan:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">{routeData.title}</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Usuario(s) asignado(s):</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">
                      {routeData.status === 'created' ||
                        routeData.status === 'by_integration'
                        ? getAssignedUsers(routeData.route_relations_headers)
                        : 'Sin usuarios asignados'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Cantidad de clientes:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">{routeData.client_uids.length}</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Estado del plan:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">
                      {routeData.status === 'created' ||
                        routeData.status === 'by_integration'
                        ? 'Activo'
                        : 'Deshabilitado'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Fecha de creación:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">
                      {routeData.created_at
                        ? dayjs(routeData.created_at).format('DD/MM/YYYY')
                        : '-'}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="mr-85 mb-10">
                      <b>Fecha de actualización:</b>
                    </div>
                  </td>
                  <td>
                    <div className="mb-10">
                      {routeData.updated_at
                        ? dayjs(routeData.updated_at).format('DD/MM/YYYY')
                        : '-'}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />

            <div className="show-data-details">
              <div>
                <b>Detalles de clientes:</b>
              </div>
            </div>

            <Table hover responsive>
              <thead className="table-header-gray">
                <tr>
                  <th>CLIENTE</th>
                  <th>FECHA DE INICIO</th>
                  <th>DÍA(S) DE VISITA</th>
                  <th>RECURRENCIA</th>
                </tr>
              </thead>
              <tbody>
                {routeData.status === 'by_integration'
                  ? routeData.route_relations_details.map((details, index) => (
                    <tr key={index}>
                      <td>
                        {details.client_uid} - {details.client_name}
                      </td>
                      <td>{dayjs(details.start_date).format('DD/MM/YYYY')}</td>
                      <td>{getVisitDaysInWords(details.days_of_the_week)}</td>
                      <td>{getRecurrenceInWords(details.recurrence, '7')}</td>
                    </tr>
                  ))
                  : sortedClients.map((details, index) => (
                    <tr key={index}>
                      <td>
                        {details.value} - {details.label}
                      </td>
                      <td>{dayjs(details.startDate).format('DD/MM/YYYY')}</td>
                      <td>{getVisitDaysInWords(details.visitDays)}</td>
                      <td>
                        {getRecurrenceInWords(
                          details.recurrence,
                          details.recurrenceType
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </>
  )
}

export default ShowRoutePlanView
